module.exports = __webpack_public_path__ + "img/dod_day12_image_05.740d9a7c.jpg";